import React, { useState } from "react";
import Day from "./Day";
import { v4 as uuidv4 } from "uuid";
import { DragDropContext } from "react-beautiful-dnd";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { SET_TIMESLOTS } from "../../../Constants/reducerEvents";
import { Button } from "@mui/material";
const days = ["Sun", "Mon", "Tues", "Wed", "Thurs", "Fri", "Sat"];

export default function ScheduleTasks() {
  const tasks = useSelector((state) => state.timeslots);
  const [weekOffset, setWeekOffset] = useState(0);
  const dispatch = useDispatch();
  const setTasks = (newTimeslots) => {
    dispatch({ type: SET_TIMESLOTS, payload: newTimeslots });
  };
  function handleOnDragEnd(result) {
    // console.log(result);
    if (!result.destination) return;
    const newTasks = tasks.map((t) => {
      if (t.id === result.draggableId) {
        return {
          ...t,
          index: result.destination.index,
          date: result.destination.droppableId,
        };
      } else if (
        moment(t.date).isSame(result.source.droppableId, "day") &&
        moment(t.date).isSame(result.destination.droppableId, "day")
      ) {
        //same container
        let off = 0;

        if (t.index > result.source.index) {
          off = -1;
        }
        if (t.index > result.destination.index) {
          off = 1;
        }
        if (
          t.index > result.source.index &&
          t.index > result.destination.index
        ) {
          off = 0;
        }
        if (t.index === result.destination.index) {
          if (t.index > result.source.index) {
            off = -1;
          } else {
            off = 1;
          }
        }
        return { ...t, index: t.index + off };
      } else if (moment(t.date).isSame(result.source.droppableId, "day")) {
        //same as source

        if (t.index > result.source.index) {
          return { ...t, index: t.index - 1 };
        } else {
          return t;
        }
      } else if (moment(t.date).isSame(result.destination.droppableId, "day")) {
        //same as destination
        if (t.index >= result.destination.index) {
          return { ...t, index: t.index + 1 };
        } else {
          return t;
        }
      } else {
        return t;
      }
    });
    // console.log(newTasks);
    setTasks(newTasks);
  }
  const clickDot = (task, num) => {
    setTasks([
      ...tasks,
      {
        name: task.name,
        date: task.date,
        index: num,
        taskId: task.id,
        id: uuidv4(),
      },
    ]);
  };
  const setComplete = (task) => {
    setTasks(tasks.filter((ta) => ta.id !== task.id));
  };
  const addNewTask = (task, num, date) => {
    setTasks([
      ...tasks,
      {
        name: task,
        date,
        index: num,
        taskId: null,
        id: uuidv4(),
      },
    ]);
  };
  return (
    <div style={{ height: "500px" }}>
      <DragDropContext onDragEnd={handleOnDragEnd}>
        <table style={{ width: "100%", height: "100%" }}>
          <thead>
            {days.map((d) => (
              <td
                style={{
                  width: `${100 / 7}%`,
                  textAlign: "center",
                  fontSize: "22px",
                }}
              >
                {d}
              </td>
            ))}
          </thead>
          <tbody style={{ backgroundColor: "#ddd" }}>
            <tr style={{ height: "50%" }}>
              {[...new Array(7)].map((d, i) => (
                <Day
                  offset={i + 7 * weekOffset}
                  tasks={tasks.sort((a, b) => a.index - b.index)}
                  clickDot={(task, num) => clickDot(task, num, i)}
                  setComplete={setComplete}
                  addNewTask={addNewTask}
                />
              ))}
            </tr>
            <tr>
              {[...new Array(7)].map((d, i) => (
                <Day
                  offset={i + 7 + 7 * weekOffset}
                  tasks={tasks.sort((a, b) => a.index - b.index)}
                  clickDot={(task, num) => clickDot(task, num, i + 7)}
                  setComplete={setComplete}
                  addNewTask={addNewTask}
                />
              ))}
            </tr>
          </tbody>
        </table>
      </DragDropContext>
      <div style={{ display: "flex" }}>
        <Button onClick={() => setWeekOffset((w) => w - 1)}>{"<"}</Button>
        <Button
          style={{ marginRight: 0, marginLeft: "auto" }}
          onClick={() => setWeekOffset((w) => w + 1)}
        >
          {">"}
        </Button>
      </div>
    </div>
  );
}
